const onBoardingSessionStorageKey = 'pendingOnBoardingPopup';
const sessionStorageKey = 'pendingDynamicSuburbsPopup';
const merchantHostedStorageKey = 'pendingMerchantHostedLogic';

class NotificationPanelController {
    constructor($window, $rootScope, $scope, $state, sessionStorage, settings, expressService, shopperService, loginService, analytics, trolleyService, userPreferenceService, inStoreProductService) {
        this.$window = $window;
        this.$scope = $scope;
        this.$state = $state;
        this.sessionStorage = sessionStorage;
        this.settings = settings;
        this.expressService = expressService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.analytics = analytics;
        this.trolleyService = trolleyService;
        this.userPreferenceService = userPreferenceService;
        this.inStoreProductService = inStoreProductService;
        this.$rootScope = $rootScope;
    }

    $onInit() {
        this.shouldDisplayDynamicSuburbDialog = false;
        this.shouldDisplayExpressSelectedDialog = false;
        this.shouldDisplayFulfillmentSelectorDialog = false;
        this.shouldDisplayOnboardingDialog = false;

        this.$scope.$on('login:success', () => {
            this.sessionStorage.set(sessionStorageKey, true);
        });

        this.$scope.$on('session:timeout', () => {
            this.shouldDisplayDynamicSuburbDialog = false;
            this.shouldDisplayExpressSelectedDialog = false;
            this.shouldDisplayFulfillmentSelectorDialog = false;
            this.shouldDisplayOnboardingDialog = false;
        });

        if (this.sessionStorage.getAndRemove(sessionStorageKey)) {
            this.showDynamicSuburbsDialog();

            // Feature switch for onboarding
            if (this.settings.content.enableFulfilmentSelectorModal) {
                this.sessionStorage.set(onBoardingSessionStorageKey, true);
            }
        }

        this.showExpressSelectedDialog();

        this.shouldShowFMS = this.inStoreProductService.shouldShowFMS();

        // Show onboarding screen
        if ((this.sessionStorage.getAndRemove(onBoardingSessionStorageKey) || this.shouldShowFMS)
            && !this.shouldDisplayDynamicSuburbDialog
            && !this.shouldDisplayExpressSelectedDialog) {
            switch (this.$state.current.name) {
                case 'shop.confirmation':
                case 'shop.myaccount.trackmyorder': {
                    break;
                }
                case 'shop.inspiration.parent.child': {
                    if (this.$state.params.parent !== 'meals-at-woolworths' && this.$state.params.child !== 'meal-planner') {
                        this.showOnboardingDialog();
                    }
                    break;
                }
                default: {
                    this.defaultShouldShowOnboarding();
                    break;
                }
            }
        }
        this.$rootScope.$on('FMS:close', () => {
            if (this.sessionStorage.get(merchantHostedStorageKey)) {
                this.$window.location.reload();
            } else {
                this.inStoreProductService.addSavedProductToCart();
            }
        });

        if (this.sessionStorage.getAndRemove(merchantHostedStorageKey)) {
            this.inStoreProductService.addSavedProductToCart();
        }
    }

    defaultShouldShowOnboarding() {
        const loginTrigger = this.sessionStorage.getAndRemove('login:trigger');
        switch (loginTrigger) {
            case 'GuestLoginToSaveAddress':
            case 'GuestLoginToFavouriteRecipe': {
                break;
            }
            default: {
                this.showOnboardingDialog(); // all other cases, show FMS/onboarding
                break;
            }
        }
    }

    shouldShowfulfilmentSelector(date1, date2, callback) {
        if (this.shouldShowFMS || !date1 || !date2) {
            callback();
            return;
        }
        date1.setHours(0, 0, 0, 0);
        date2.setHours(0, 0, 0, 0);
        if (date1.getTime() !== date2.getTime()) {
            callback();
        }
    }

    closeOnBoardingDialog() {
        this.userPreferenceService.getUserPreference().then((result) => {
            const lastSeen = new Date(result.LastViewFulfilmentSelector);
            const today = new Date();
            this.shouldShowfulfilmentSelector(lastSeen, today, () => {
                this.showFulfilmentSelectorDialog();
                this.userPreferenceService.setLastViewFulfilmentMethodSelector(today);
            });
        });
    }

    showOnboardingDialog() {
        this.userPreferenceService.getUserPreference().then((result) => {
            if (!result.HasDoneOnboarding) {
                this.shouldDisplayOnboardingDialog = true;
            } else {
                this.closeOnBoardingDialog();
            }
        });
    }

    showFulfilmentSelectorDialog() {
        this.shouldDisplayFulfillmentSelectorDialog =
            this.settings.content.enableFulfilmentSelectorModal && !this.shouldDisplayDynamicSuburbDialog && !this.shouldDisplayExpressSelectedDialog;
    }

    showDynamicSuburbsDialog() {
        this.shouldDisplayDynamicSuburbDialog = !this.shopperService.IsGuest &&
            this.shopperService.shopper.ShouldShowDeliveryWindowDialog &&
            this.loginService.loginContext !== 'checkout';

        if (this.shouldDisplayDynamicSuburbDialog) {
            this.analytics.pushEvent('dynamic suburbs popup presented');
        }
    }

    showExpressSelectedDialog() {
        this.shouldDisplayExpressSelectedDialog = this.expressService.shouldShowExpressSelectedDialog() &&
            this.$state.current.name === 'root';
    }
}

NotificationPanelController.$inject = ['$window', '$rootScope', '$scope', '$state', 'SessionStorageWrapper', 'Settings', 'ExpressService', 'ShopperService', 'LoginService', 'AnalyticsService', 'TrolleyService', 'UserPreferenceService', 'InStoreProductService'];

const notificationPanelComponentDefinition = {
    controller: NotificationPanelController,
    template: require('./notification-panel.component.html').trim(),
};

module.exports = {
    NotificationPanelController,
    notificationPanelComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/notificationpanel/notification-panel.component.js